<template>
  <div class="signin form-user">
    <h1 class="title is-4">Đăng nhập</h1>
    <form @submit.prevent="validateBeforeSubmit">
      <b-field
        :type="{'is-danger': errors.has('username')}"
        :message="errors.first('username')"
        custom-class="has-text-weight-normal body-text"
      >
        <template slot="label">
          Tên đăng nhập <span class="has-text-danger">*</span>
        </template>
        <b-input
          v-model="username"
          name="username"
          v-validate="{required: true, regex: /\w$/, min: 4}"
          size="is-medium"
          data-vv-as="Tên đăng nhập"
        ></b-input>
      </b-field>

      <b-field
        label="Mật khẩu"
        :type="{'is-danger': errors.has('password')}"
        :message="errors.first('password')"
        custom-class="has-text-weight-normal body-text"
      >
        <template slot="label">
          Mật khẩu <span class="has-text-danger">*</span>
        </template>
        <b-input
          v-model="password"
          type="password"
          name="password"
          v-validate="{required: true, min: 5}"
          size="is-medium"
          data-vv-as="Mật Khẩu"
        ></b-input>
      </b-field>
      <b-field
        :type="{'is-danger': errors.has('captcha')}"
        :message="errors.first('captcha')"
        class="recaptcha"
        custom-class="has-text-weight-normal body-text"
      >
        <template slot="label">
          Mã xác nhận <span class="has-text-danger">*</span>
        </template>
        <b-input
          v-model="reCaptchaAdmin"
          name="captcha"
          v-validate="`required|compare_captcha:${captcha&&captcha.text}`"
          size="is-medium"
          data-vv-as="Mã xác nhận"
        ></b-input>
        <div v-html="captcha.svg" class="recaptcha-image" v-if="captcha"></div>
        <div class="recaptcha-input" @click="reloadCaptcha">
          <b-icon type="is-primary" icon="sync" pack="fa"></b-icon>
        </div>
      </b-field>
      <button
        type="submit"
        class="button is-info button-login"
        :class="{'is-loading': isLoaded}"
        :disabled="isLoaded"
      >Đăng nhập</button>
    </form>
    <br>
    <p>
      <button
        class="button is-info is-small button-login-party"
        @click="isFormModalActive=true">
        Đăng nhập cho người dùng cuối
      </button>
    </p>
    <b-modal :active.sync="isFormModalActive" :width="440" scroll="keep">
      <div class="modal-participant">
        <h2 class="title is-4">Đăng nhập cho người dùng cuối</h2>
        <form @submit.prevent="validateBeforeSubmitModal('form-2')" data-vv-scope="form-2">
          <b-field
            :type="{'is-danger': errors.has('form-2.username')}"
            :message="errors.first('form-2.username')"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Tên đăng nhập <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="participant"
              name="username"
              v-validate="{required: true, regex: /\w$/, min: 4}"
              size="is-medium"
              data-vv-as="Tên đăng nhập"
            ></b-input>
          </b-field>

          <b-field
            :type="{'is-danger': errors.has('form-2.password')}"
            :message="errors.first('form-2.password')"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Mật khẩu <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="participantPassword"
              type="password"
              name="password"
              v-validate="{required: true, min: 5}"
              size="is-medium"
              data-vv-as="Mật khẩu"
            ></b-input>
          </b-field>
          <b-field
            :type="{'is-danger': errors.has('form-2.captchaParticipant')}"
            :message="errors.first('form-2.captchaParticipant')"
            class="recaptcha"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Mã xác nhận <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="reCaptchaUser"
              name="captchaParticipant"
              v-validate="`required|compare_captcha:${captcha&&captcha.text}`"
              size="is-medium"
              data-vv-as="Mã xác nhận"
            ></b-input>
            <div v-html="captcha.svg" class="recaptcha-image" v-if="captcha"></div>
            <div class="recaptcha-input" @click="reloadCaptcha">
              <b-icon type="is-primary" icon="sync" pack="fa"></b-icon>
            </div>
          </b-field>
          <div class="field is-grouped is-grouped-centered">
            <div class="control">
              <b-button
                class="button"
                @click="isFormModalActive=false"
              >Đóng</b-button>
            </div>
            <div class="control">
              <button
                type="submit"
                class="button is-info"
              >Đăng nhập</button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import UsersService from '../services/UsersService'
import {SERECT_KEY} from '../config'
import CryptoJS from 'crypto-js';

export default {
  name: "NewUser",
  data() {
    return {
      username: "",
      password: "",
      email: "",
      isLoaded: false,
      isFormModalActive: false,
      participant: "",
      participantPassword: '',
      captcha: null,
      reCaptchaAdmin: null,
      reCaptchaUser: null
    };
  },
  created() {
    this.reloadCaptcha()
  },
  methods: {
    ...mapActions("auth", ["logIn", "resendEmail"]),
    ...mapActions("authParticipant", ["logInParticipant"]),
    logInClient() {
      this.isLoaded = true;
      const txtencrypt = CryptoJS.AES.encrypt(JSON.stringify({ user: {
          username: this.username,
          password: this.password
        }}), SERECT_KEY).toString();
      this.logIn({
        data: txtencrypt
      })
        .then(res => {
          if (res.data.status) {
            if(this.username === 'admin.report') {
              this.$router.push({
                name: "Report"
              });
              return;
            }
            this.$router.push({
              name: "Room"
            });
          } else {
            if(res.data.verify) {
              this.email = res.data.email;
              this.$dialog.confirm({
                message: 'Tài khoản của bạn chưa được xác minh. Vui lòng kiểm tra email của bạn hoặc bấm đồng ý để hệ thống gửi lại email xác minh!',
                onConfirm: () => {
                  this.resend();
                },
                confirmText: 'Đồng ý',
                cancelText: 'Đóng'
              })
            } else {
              this.$toast.open({
                duration: 5000,
                message: res.data.message,
                type: "is-danger"
              });
            }
            this.resetForm();
            this.$nextTick(() => {
              this.$validator.reset();
            });
          }
        })
        .catch(() => {
          this.$toast.open({
            duration: 5000,
            message: "Lỗi mấy chủ. Vui lòng thử lại",
            type: "is-info"
          });
        })
        .finally(() => {
          this.isLoaded = false;
        });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.logInClient();
          return;
        }
      });
    },
    resetForm() {
      this.username = "";
      this.password = "";
      this.reloadCaptcha();
    },
    resend() {
      this.resendEmail({email: this.email}).then(() => {
        this.$toast.open('Vui lòng kiểm tra email của bạn!')
      }).catch(err => {
        this.$toast.open(err)
      })
    },
    validateBeforeSubmitModal(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result && this.captcha.text === this.reCaptchaUser) {
          this.logInModal();
        }
      });
    },
    logInModal() {
      const self = this;
      this.logInParticipant({
        participant: {
          participantName: this.participant,
          participantPass: this.participantPassword
        }
      }).then(res => {
        if (res.data.status) {
          self.$router.push({
            name: "Conversation"
          });
        } else {
          this.participant = "";
          this.participantPassword = '';
          this.reloadCaptcha();
          this.$nextTick(() => {
            this.$validator.reset();
          });
          self.$toast.open({
            duration: 5000,
            message: res.data.message,
            type: "is-danger"
          });
        }
      })
      .catch(() => {
        self.$toast.open({
          duration: 5000,
          message: "Lỗi máy chủ. Vui lòng thử lại",
          type: "is-info"
        });

      })

    },
    reloadCaptcha() {
      this.reCaptchaAdmin = ''
      this.reCaptchaUser = ''
      UsersService.getCaptcha().then(res => {
        const data = res.data.data;
        const bytes  = CryptoJS.AES.decrypt(data, 'appSecretPassCodePolycom');
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        this.captcha = JSON.parse(originalText)
      });
    }
  }
};
</script>

<style lang="scss" scope>

  .modal-participant {
    background: #fff;
    padding: 30px;
    border-radius: 10px;
  }

  .button.is-info.button-login {
    width: 100%;
    margin-top: .2rem;
  }

  .button-participant {
    border: none;
    color: #00abe9;
  }

  .button.is-info.button-login-party {
    font-size: 14px;
  }

</style>